/**
 * Before and After Slider Component
 */

class BeforeAfterSlider {
  constructor(element) {
    this.slider = element;
    this.divider = this.slider.querySelector('[data-js="divider"]');
    this.handle = this.slider.querySelector('[data-js="handle"]');
    this.afterImage = this.slider.querySelector('.before-after-section__image--after');
    this.container = this.slider.querySelector('.before-after-section__image-container');
    
    this.isDragging = false;
    this.currentPosition = 50; // Start at 50%
    
    this.init();
  }
  
  init() {
    if (!this.divider || !this.handle || !this.afterImage || !this.container) {
      return;
    }
    
    this.bindEvents();
    this.updatePosition(this.currentPosition);
  }
  
  bindEvents() {
    // Mouse events
    this.handle.addEventListener('mousedown', this.startDrag.bind(this));
    document.addEventListener('mousemove', this.drag.bind(this));
    document.addEventListener('mouseup', this.stopDrag.bind(this));
    
    // Touch events for mobile
    this.handle.addEventListener('touchstart', this.startDrag.bind(this), { passive: false });
    document.addEventListener('touchmove', this.drag.bind(this), { passive: false });
    document.addEventListener('touchend', this.stopDrag.bind(this));
    
    // Click on container to move divider
    this.container.addEventListener('click', this.handleClick.bind(this));
    
    // Prevent default drag behavior on images
    this.slider.addEventListener('dragstart', (e) => e.preventDefault());
  }
  
  startDrag(e) {
    this.isDragging = true;
    this.handle.style.cursor = 'grabbing';
    e.preventDefault();
  }
  
  drag(e) {
    if (!this.isDragging) return;
    
    e.preventDefault();
    
    const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    this.updatePositionFromClientX(clientX);
  }
  
  stopDrag() {
    this.isDragging = false;
    this.handle.style.cursor = 'grab';
  }
  
  handleClick(e) {
    if (this.isDragging) return;
    
    const clientX = e.clientX;
    this.updatePositionFromClientX(clientX);
  }
  
  updatePositionFromClientX(clientX) {
    const rect = this.container.getBoundingClientRect();
    const x = clientX - rect.left;
    const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
    
    this.updatePosition(percentage);
  }
  
  updatePosition(percentage) {
    this.currentPosition = percentage;
    
    // Update divider position
    this.divider.style.left = `${percentage}%`;
    
    // Update after image clip-path
    this.afterImage.style.clipPath = `polygon(${percentage}% 0%, 100% 0%, 100% 100%, ${percentage}% 100%)`;
  }
}

// Initialize all before-after sliders
function initBeforeAfterSliders() {
  const sliders = document.querySelectorAll('[data-js="before-after-slider"]');
  
  sliders.forEach(slider => {
    new BeforeAfterSlider(slider);
  });
}

// Auto-initialize when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBeforeAfterSliders);
} else {
  initBeforeAfterSliders();
}

export { BeforeAfterSlider, initBeforeAfterSliders };
